export class VerifyEmailModel {
    public verificationToken: string;
    public languageId: number;
}